import React, { useEffect } from 'react'
import Background from './../bg.webp'

const Portrait = () => {

    useEffect(() => {
        const handlePreventZoom = (e: any) => {
            e.preventDefault();
            // @ts-ignore
            document.body.style.zoom = 0.99;
        }

        const handlePreventZoomEnd = (e: any) => {
            e.preventDefault();
            // @ts-ignore
            document.body.style.zoom = 1;
        }
        document.addEventListener("gesturestart", handlePreventZoom);
        document.addEventListener("gesturechange", handlePreventZoom);
        document.addEventListener("gestureend", handlePreventZoomEnd);

        return () => {
            document.removeEventListener("gesturestart", handlePreventZoom);
            document.removeEventListener("gesturechange", handlePreventZoom);
            document.removeEventListener("gestureend", handlePreventZoomEnd);
        }
    }, []);

    return (
        <><div className="bg-wrapper">
            <img onContextMenu={(e) => e.preventDefault()} draggable="false" alt='' src={Background} className='background-image' />
        </div>
        </>
    )
}

export default Portrait